import {
  Zap,
  Lock,
  BadgeCheck,
  MessageCircle,
  Package,
  Rocket,
  Truck,
  Headphones,
  Clapperboard,
  Gem,
} from "lucide-react";

const map = {
  Zap,
  Lock,
  BadgeCheck,
  MessageCircle,
  Package,
  Rocket,
  Truck,
  Headphones,
  Clapperboard,
  Gem,
};

export const Icon = ({ name, ...props }) => {
  const Cmp = map[name] || Gem;
  return <Cmp {...props} />;
};
